/**
 * Замеренная высота закреплённого футера. Пишет `Screen.Footer`, читает `Screen.Content` —
 * это его нижний резерв (см. Screen.module.scss). Пока футера нет, переменная не объявлена,
 * и в CSS работает запасное значение из токена `reserve-menu-cta`.
 */
export const FOOTER_HEIGHT_VAR = '--screen-footer-height'
